import React, { FC } from "react";
import { Link } from "@natera/navigation";
import Svg from "@natera/material/lib/svg";
import "./detailInformationButton.scss";

export interface DetailInformationButtonProps {
  route: string;
  name: string;
  startIcon: string;
  endIcon: string;
  linkState?: unknown;
}

const DetailInformationButton: FC<DetailInformationButtonProps> = ({
  route,
  name,
  startIcon,
  endIcon,
  linkState,
}) => {
  return (
    <Link className="detail-information-button" to={route} state={linkState}>
      <Svg content={startIcon} />
      <div>{name}</div>
      <Svg content={endIcon} />
    </Link>
  );
};

export default DetailInformationButton;
